import {useEffect} from 'react'

import {sendErrorToNelo} from '@web/helpers/nelo'
import {getPageSetByPathname} from '@web/slices/common/slice'

export function useErrorLogger() {
    useEffect(() => {
        const handleError = (evt: ErrorEvent) => {
            if (evt.filename.startsWith(window.location.origin)) {
                sendErrorToNelo('GlobalError', evt.error, getPageSetByPathname())
            }
        }

        const handleUnhandledrejection = (evt: PromiseRejectionEvent) => {
            sendErrorToNelo('GlobalUnhandledRejection', evt.reason, getPageSetByPathname())
        }

        window.addEventListener('error', handleError)
        window.addEventListener('unhandledrejection', handleUnhandledrejection)
        return () => {
            window.removeEventListener('error', handleError)
            window.removeEventListener('unhandledrejection', handleUnhandledrejection)
        }
    }, [])
}
